import { render, staticRenderFns } from "./CreateContracts.vue?vue&type=template&id=6917c8f6"
import script from "./CreateContracts.vue?vue&type=script&lang=js"
export * from "./CreateContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports